import React from 'react';
import SwiperCore, { Navigation, Autoplay } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';

SwiperCore.use([Navigation, Autoplay]);

export default function IconsSlider({ items, className }) {
    return (
        <div className={ cx('slider-swiper-container', className) }>
            {items.length > 3 ? (
                <Swiper
                  modules={ [Navigation, Autoplay] }
                  navigation
                  className="slider-slider"
                  slidesPerView={ 1 }
                  loop
                  spaceBetween={ 0 }
                  scrollbar={ false }
                  autoplay={ {
                    delay: 7000,
                    disableOnInteraction: true
                  } }
                  breakpoints={ {
            1281: {
              slidesPerView: items.length > 1 ? 4 : 1
            },
            767: {
              slidesPerView: 3
            },
            479: {
              slidesPerView: 2
            },
            320: {
              slidesPerView: 1
            }
          } }
                >
                    {items.map((item) => (
                        <SwiperSlide key={ item.id }>
                            <div
                              id={ `scroll-${ item.id }` }
                              style={ { width: '100%', margin: 0, padding: 0 } }
                            >
                                <div className="icon-item">
                                    <span className="icon-image">
                                        {item.url ? (
                                            <a href={ `${ item.url }` } rel="nofollow">
                                                <img
                                                  src={ item.imgUrl }
                                                  alt={ item.title }
                                                />
                                            </a>
                    ) : (
                        <img
                          src={ item.imgUrl }
                          alt={ item.title }
                        />
                    )}
                                    </span>
                                </div>
                            </div>
                        </SwiperSlide>
          ))}
                </Swiper>
      ) : (
          <div
            style={ {
            marginTop: '60px',
            marginBottom: '60px',
            display: 'flex',
            alignItems: 'center'
          } }
            className={ `no-swiper-${ items.length }` }
          >
              {items.map((item, index) => (
                  <div className="icon-item" key={ index }>
                      <span className="icon-image">
                          <img src={ item.imgUrl } alt={ item.title }/>
                      </span>
                  </div>
          ))}
          </div>
      )}
        </div>
    );
}
IconsSlider.defaultProps = {
    items: [],
    className: ''
};

IconsSlider.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        title: PropTypes.string.isRequired,
        imgUrl: PropTypes.string.isRequired,
        id: PropTypes.number.isRequired,
        url: PropTypes.string
    })),
    className: PropTypes.string
};



// WEBPACK FOOTER //
// ./src/components/IconsSlider.jsx